export default [

     {
          path: '/third-party-contract-type',
          name: 'ThirdPartyContractType',
          component: () => import("@/views/Page/ThirdPartyContractType/ThirdPartyContractType.vue"),
           meta: {
               title: 'ThirdPartyContractType',
          },
     }
];